import React, { useRef, useState, useEffect, useContext, createContext } from "react";
// import Service from '../../../services/httpService'

export const UserTypeContext = createContext('Default Value');

